import React, { PropsWithChildren } from 'react';
import { useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedRef, useScrollOffset } from 'react-native-reanimated';
import { SafeAreaView } from 'react-native-safe-area-context';

import { CustomNavigationHeader, theme, useResponsive } from '@sg/garnish';

import { FlexLandingPageLogo } from './FlexLandingPageLogo';

export const FlexLandingPageContainer = (props: PropsWithChildren) => {
  const { currentBreakpoint, match } = useResponsive();
  const { formatMessage } = useIntl();
  const router = useRouter();

  const animatedRef = useAnimatedRef<Animated.ScrollView>();
  const scrollOffsetSV = useScrollOffset(animatedRef);

  return (
    <Animated.ScrollView
      ref={animatedRef}
      contentContainerStyle={styles.scrollView}
      stickyHeaderIndices={match([[0], []])}
    >
      {currentBreakpoint.isXS ? (
        <CustomNavigationHeader.Container
          safeAreaEdges={[]}
          palette="default"
          scrollOffsetSV={scrollOffsetSV}
        >
          <CustomNavigationHeader.Button.Left
            name="IconArrowLeft"
            accessibilityLabel={formatMessage(messages.goBack)}
            onPress={router.back}
          />

          <CustomNavigationHeader.Content scrollOffsetSV={scrollOffsetSV}>
            <FlexLandingPageLogo placement="header" />
          </CustomNavigationHeader.Content>
        </CustomNavigationHeader.Container>
      ) : null}

      <SafeAreaView style={match([styles.containerXS, styles.containerSM])} edges={[]}>
        {props.children}
      </SafeAreaView>
    </Animated.ScrollView>
  );
};

const FlexLandingPageContainerContent = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  return <View style={match([styles.contentXS, styles.contentSM])}>{props.children}</View>;
};

FlexLandingPageContainer.Content = FlexLandingPageContainerContent;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  scrollView: {
    flexGrow: 1,
  },
  containerXS: {
    flexGrow: 1,
  },
  containerSM: {
    flexGrow: 1,
    paddingTop: theme.spacing['10'],
  },
  contentXS: {
    gap: theme.spacing['6'],
  },
  contentSM: {
    gap: theme.spacing['10'],
  },
});

const messages = defineMessages({
  goBack: {
    defaultMessage: 'Go back',
    description: 'Flex Landing Page | Header | Back button',
  },
});
